import type { TokenRequestParams } from "owa-tokenprovider-utils";
import type { HeadersWithoutIterator, RequestOptions } from "owa-service/lib/RequestOptions";
import { getUserToken } from "./userTokenHandler";
import type TokenResponse from "owa-service/lib/contract/TokenResponse";

export async function getUserTokenIfAvailable(params: TokenRequestParams): Promise<TokenResponse | undefined> {
    let options: RequestOptions | undefined;
    if (params.wwwAuthenticateHeader) {
        const headers: HeadersWithoutIterator = new Headers();
        headers.set("WWW-Authenticate", params.wwwAuthenticateHeader);
        options = { headers };
    }
    
    return getUserToken(options, params.mailboxInfo, params.requestId);
}
